import {
  Link, Spinner, Text,
} from '@chakra-ui/react';
import Image from 'next/image';

// 2
export default function Brand(props) {
  return (
    <Text as='span' {...props}>FUNWOO</Text>
  );
}

const BrandWithImage = (props) => (
  <Image
    width={133}
    height={40}
    {...props}
  />
);

export const BrandImage = (props) => (
  <BrandWithImage
    {...props}
    src='/logo-black.png'
  />
);

export const BrandImageBlack = (props) => (
  <BrandWithImage
    {...props}
    src='/logo-black.png'
  />
);

export const BrandImageWhite = (props) => (
  <BrandWithImage
    {...props}
    src='/logo-black.png'
  />
);

//
export const BrandSpinner = (props) => (
  <strong
    {...props}
  >
    FUNW
    <Spinner
      size='xl'
      emptyColor='gray.200'
      speed='.8s'
      thickness='4px'
    />
    <Spinner
      size='xl'
      emptyColor='gray.200'
      speed='.8s'
      thickness='4px'
    />
  </strong>
);

//
export const BrandLink = () => (
  <Link
    href='/'
  >
    <Brand />
  </Link>
);
